import * as React from "react";
import {
  Button,
  DialogActions,
  Dialog,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import PropTypes from "prop-types";

const Consulta = (props) => {
  const { datos, /*ar,*/ open, onClose, onSave } = props;
  return (
    <Dialog open={open} onClose={onClose} size="xs">
      <DialogContent>
        <DialogContentText>
          {datos && '¿Recibió el elemento "' + datos.Descripcion + '"?'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onSave}>Sí</Button>
        <Button onClick={onClose}>No</Button>
      </DialogActions>
    </Dialog>
  );
};
Consulta.propTypes = {
  datos: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
};
export default Consulta;
